import { EnrichedField } from "../../api/enrichApi";
import { ValidatedFieldsetField } from "../../api/fieldsetApi";

export const hasEnrichPimValue = (val: unknown): boolean => {
  if (val == null) {
    return false;
  }
  if (typeof val === "string" || Array.isArray(val)) {
    return val.length > 0;
  }
  if (typeof val === "object") {
    return Object.keys(val).length > 0;
  }
  return true;
};

export const wouldOverwriteEnrichPimValue = (
  f: Pick<EnrichedField, "existing_pim_value" | "published">
): boolean => !f.published && hasEnrichPimValue(f.existing_pim_value);

export const formatTimestamp = (
  iso: string | null | undefined
): string | undefined =>
  iso ? new Date(iso).toISOString().replace("T", " ").slice(0, 19) : undefined;

export const hasExistingPimValue = (f: ValidatedFieldsetField): boolean => {
  const v = f.value;
  if (v == null || v === "") {
    return false;
  }
  if (Array.isArray(v)) {
    return v.length > 0;
  }
  return true;
};

export const validatedFieldToEnrichedField = (
  f: ValidatedFieldsetField
): EnrichedField => ({
  id: 0,
  key: f.key,
  display_key: f.display_key,
  description: null,
  value: f.value ?? (f.type === "BOOLEAN" ? false : ""),
  reasoning: null,
  type: (f.type as EnrichedField["type"]) ?? null,
  options: f.options ?? {},
  is_edited: false,
  published: null,
  send_error: null,
  enrich_error: null,
  customer_field_id: f.customer_field_id,
  existing_pim_value: null,
  latest_enrichment: null,
  latest_edit: null,
});
